export type DateTimeFormatType =
  | 'Time'
  | 'NumericDay'
  | 'ShortDay'
  | 'WeekdayAndTime'
  | 'WeekdayAndMonthAndNumericDay'
  | 'MonthDayAndTime'
  | 'MonthDayAndYear'
  | 'MonthDayYearAndTime'
  | 'ShortMonth'
  | 'ShortMonthAndDay'
  | 'ShortMonthDayAndYear'
  | 'ShortMonthAndYear'
  | 'ShortMonthDayAndTime'
  | 'ShortMonthDayYearAndTime';

export const dateTimeFormatOptionsMap: Record<DateTimeFormatType, Intl.DateTimeFormatOptions> = {
  Time: {
    hour: 'numeric',
    minute: 'numeric',
  },
  NumericDay: {
    day: 'numeric',
  },
  ShortDay: {
    weekday: 'short',
  },
  WeekdayAndTime: {
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
  },
  WeekdayAndMonthAndNumericDay: {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  },
  MonthDayAndTime: {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  MonthDayAndYear: {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  },
  MonthDayYearAndTime: {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  ShortMonth: {
    month: 'short',
  },
  ShortMonthAndDay: {
    month: 'short',
    day: 'numeric',
  },
  ShortMonthDayAndYear: {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  },
  ShortMonthAndYear: {
    month: 'short',
    year: 'numeric',
  },
  ShortMonthDayAndTime: {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  ShortMonthDayYearAndTime: {
    hour: 'numeric',
    minute: 'numeric',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  },
} as const;
